import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isLoadingVisible } from '../store/selectors';
import styled from 'styled-components';

import { colors } from '../lib/global-styles';
import loadingImage from '../images/loader.gif';

const LoadingWrapper = styled.div`
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${colors.white} url(${loadingImage}) center center no-repeat;
  opacity: 0.8;
  z-index: 1002;
`;

const Loading = ({ isVisible }) => (isVisible ? <LoadingWrapper /> : null);

Loading.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isVisible: isLoadingVisible(state),
});

export default connect(mapStateToProps)(Loading);
